module.exports = __webpack_public_path__ + "media/images/gallery/constellations/libra/lib_pn-3ea034917536283e226a0b578dbc1461.gif";